import React from "react";
import { useSelector } from "react-redux";

import { RootState } from "@/store/store";

import PersonRow from "./person-row/person-row";
import { usePMIContext } from "../../../provider/private-medical-insurance.provider";
import { OptionSelectionType } from "../../../types/private-medical-insurance.type";
import brandClassNames from "../../../utils/private-medical-insurance-classes.utils";

function OptionSelection({ onOptionSelect }: Readonly<OptionSelectionType>) {
  const { toggleBtnText } = brandClassNames;
  const optionValues = [
    { label: "Yes", value: true },
    { label: "No", value: false },
  ];
  const {
    pmiDetails,
    organiserPMI,
    showOrganiserPMI,
    updateOrganiserPMI,
    organiserPMIRef,
    pmiRefs,
  } = usePMIContext();

  const { attributes } = useSelector((state: RootState) => state.quote);
  const { organiser } = attributes;

  return (
    <div className="flex flex-col md:gap-spacing-s gap-spacing-l lg:w-[450px] md:w-[400px] w-full mt-spacing-l">
      {/* Organiser PMI Section - Show first if applicable */}
      {showOrganiserPMI && organiserPMI && (
        <PersonRow
          ref={organiserPMIRef}
          person={organiserPMI}
          showOrganiserLabel
          onOptionClick={updateOrganiserPMI}
          optionValues={optionValues}
          toggleBtnText={toggleBtnText}
          testIdPrefix="organiser-pmi"
        />
      )}

      {/* Traveller PMI Details */}
      {pmiDetails?.map(
        ({ firstName, lastName, age, sequence, hasPMI }, index) => {
          const showOrganiserLabel =
            organiser?.travelling && sequence === 1 && !showOrganiserPMI;
          return (
            <PersonRow
              key={`party-type-buttons-group-${index as unknown as string}`}
              ref={pmiRefs[index]}
              person={{ firstName, lastName, age: age || 0, hasPMI }}
              showOrganiserLabel={showOrganiserLabel}
              onOptionClick={(value) => onOptionSelect(index, value)}
              optionValues={optionValues}
              toggleBtnText={toggleBtnText}
              testIdPrefix={`party-type-buttons-group-${index}`}
            />
          );
        }
      )}
    </div>
  );
}

export default OptionSelection;
